module.exports = __webpack_public_path__ + "static/media/boogle-hq.adeb3ae4.jpg";